import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { tutorialEndpoints } from 'src/app/api/api.endpoints';
import {
  ITutorialRequest,
  ITutorialResponse,
  tutorialStatusType,
} from 'src/app/api/interfaces/account.interface';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root',
})
export class TutorialService {
  public texts = {
    2: 'This is internal game currency, you can spend for mining resources and earn it from completing different in-game quests!',
    3: 'This is the Fishmaster Dollars - donate currency, you can buy it with Near. It used for buying the Licenses, Energy packs and Other booster packs',
    4: 'Hiring Licence is the card that required to hire your characters, one card for 1 character. You can buy one in the Shop later, and we are giving you your very first license for free!',
    7: "Wooohoooo Your first character is here! Let's take a closer look at him/her",
    8: "Your character's progress will appear here",
    9: "Each character has it's own energy level, that is one of the key resources for crafting ingredients and completing tasks",
    10: 'You got lucky! Look at the traits count! Green traits are positive ones and Red are negative. The more you have is better! Take a closer look into them!',
    11: 'Upon reaching a certain level, a person opens a slot for a skill, which immediately rolls. Dropped skills can be rerolled in the future with Fish Dollars and burning a certain amount of Hiring Licenses!',
    13: 'This is a visual progress of your specialties, here you can see how much experience you need in order to move a certain specialty to a new level! Crafting more complex ingredients as well as certain quests require higher levels of certain specialties, keep an eye on this on the specialty screen and level your characters in a balanced way.',
    16: 'Hey dude, tap on where the pointer is to cast the rod',
    17: 'Look at control, and tap to catch the required throw force...',
    18: 'Wait until it starts to bite...',
    19: 'Tap and hold until the fish reahes the shore...',
    20: 'It looks like there is nothing to do here without bait, you need to go to the pub and ask the bartender about the available tasks in order to be at least somehow useful in the city.',
    22: [
      "The locals here are kind, but they don’t really like visitors, so they don’t willingly give work to strangers. There are currently no orders. Everyone went fishing, but don't worry, it's a good opportunity to show off. Hold it, it will come in handy (gives you the bait)",
      "Thanks to the bartender you have the bait! Let's check how it works on the lake?",
    ],
    30: [
      'Great, I see that the bait worked well! Congratulations on a successful catch! By the way, we have a first order for you!',
      "Great, now you have your first order, let's go to your restaurant - your food production headquarters and craft your very first dish",
    ],
    43: [
      "You're doing well! Come back for new orders as soon as you can get all the necessary ingredients to craft new dishes! I will always be here to help!         Also, as part of the bonus, I will give you some Fish Dollars so that you can replenish the necessary energy reserves and purchase accelerators! Also, with their help, you can hire 1 more employee to be in time everywhere!",
      "Thanks to the bartender, you have a certain amount of donation currency - Fish Dollars, which you can spend to hire a new character! Let's move on to buying a license and opening a new slot!",
    ],
  };
  public status: tutorialStatusType = 'IN_PROCESS';
  public showTutorialBg: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  public step: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  constructor(private http: HttpClient) {}
  private markTutorialStep(
    step: ITutorialRequest
  ): Observable<ITutorialResponse> {
    return this.http.post<ITutorialResponse>(
      environment.apiUrl + tutorialEndpoints.post.markStep,
      step
    );
  }
  public goToNextStep(step?: number, reload?: boolean): void {
    if (step) {
      this.step.next(step);
    } else {
      //this.step.next(this.step.getValue() + 1);
      this.markTutorialStep({
        cityId: 1,
        step: this.step.getValue() + 1,
      }).subscribe((res) => {
        this.step.next(res.step);
        if (
          res.step === 14 ||
          res.step === 21 ||
          res.step === 24 ||
          res.step === 29 ||
          res.step === 32 ||
          res.step === 37 ||
          res.step === 45 ||
          res.step === 49
        ) {
          this.showTutorialBg.next(true);
        }
      });
    }
    let currentStep = step || this.step.getValue();
    if (reload) {
      if (currentStep <= 6) {
        this.showTutorialBg.next(true);
      }
      if (currentStep === 5) {
        this.showTutorialBg.next(true);
        this.step.next(4);
      }
      if (currentStep >= 7 && currentStep <= 14) {
        this.showTutorialBg.next(true);
        this.step.next(6);
      }
      if (currentStep >= 15 && currentStep <= 20) {
        this.step.next(15);
        this.showTutorialBg.next(true);
      }
      if (currentStep >= 22 && currentStep <= 23) {
        this.step.next(21);
        this.showTutorialBg.next(true);
      }
      if (currentStep >= 25 && currentStep <= 29) {
        this.step.next(24);
        this.showTutorialBg.next(true);
      }
      if (currentStep >= 29 && currentStep <= 30) {
        this.showTutorialBg.next(true);
        this.step.next(29);
      }
      if (currentStep === 31) {
        this.showTutorialBg.next(true);
        this.step.next(32);
      }
      if (currentStep >= 33 && currentStep <= 36) {
        this.showTutorialBg.next(true);
        this.step.next(32);
      }
      if (currentStep >= 37 && currentStep <= 40) {
        this.showTutorialBg.next(true);
        this.step.next(37);
      }
      if (currentStep >= 41 && currentStep <= 44) {
        this.step.next(43);
      }
      if (currentStep >= 45 && currentStep <= 47) {
        this.showTutorialBg.next(true);
        this.step.next(45);
      }
      if (currentStep === 48 || currentStep === 49) {
        this.showTutorialBg.next(true);
        this.step.next(49);
      }
      if (currentStep === 50) {
        this.showTutorialBg.next(true);
      }
    }
  }
}
